import type { IArticle } from '~/types/typings';

type ProfilePost = IArticle & { images?: IArticle['img'] };

export function mapProfilePost(post: ProfilePost): IArticle {
  return {
    ...post,
    img: Array.isArray(post.images) ? post.images : [],
  };
}
